import React, { useState, useEffect } from 'react';
import ChartCard from "../shared/ChartCard";
import PageTitle from "../shared/PageTitle";
import {
  CircularProgress,Table, TableBody, TableCell, TableContainer, TableRow, TableHead,Paper,Button
} from '@mui/material';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import axios from 'axios';


const BTKhusus = () => {
    const [data, setData] = useState([]);
    const [dataJumlah, setDataJumlah] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1); // Current page
    const itemsPerPage = 10; 
    const beUrl = process.env.REACT_APP_BE

    useEffect(() => {
        fetchData(); 
    }, [beUrl,currentPage]);

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const offset = (currentPage - 1) * itemsPerPage;
            const response = await axios.get(`${beUrl}/api/v1/pgsql/Khusus`, {
                params: {
                    awal: offset,
                    akhir: itemsPerPage
                },
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('token')}`,
                }
            });
            setData(response.data.data || []); 

            const responsejumlah = await axios.get(`${beUrl}/api/v1/pgsql/JumlahKhusus`, {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('token')}`,
                }
            });
            setDataJumlah(responsejumlah.data.data || []); 
        } catch (error) {
            console.error('Error fetching data:', error);
        }
        setIsLoading(false);
    };

    const numberWithCommas = (x) => {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    };
    

    const handleNextPage = () => {
        setIsLoading(true); 
        setCurrentPage(currentPage + 1);
      };
      
      const handlePreviousPage = () => {
        setIsLoading(true); 
        setCurrentPage(currentPage - 1);
      };
    
  
  return (
    <div className="grid gap-6 mt-5 mb-6 grid-cols-1 xl:grid-cols-1">
    <PageTitle>Buku Tanah Khusus</PageTitle>
    <div className="grid gap-6 mt-5 mb-6 grid-cols-1 xl:grid-cols-1">
    <ChartCard>
    {isLoading ? (
        <CircularProgress style={{ margin: '50px auto', display: 'block' }} />
    ) : data?.length > 0 ? ( // Cek apakah ada data
        
        <ResponsiveContainer width="100%" height={440}>
          <BarChart data={dataJumlah} style={{ margin: '0 auto', marginTop: '30px' }} >
            <XAxis dataKey="keperluan"  textAnchor="end" interval={0} />
            <YAxis/>
            <CartesianGrid strokeDasharray="3 3" />
            <Tooltip
              contentStyle={{
                borderRadius: '8px',
                boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
                padding: '8px',
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
              }}
              formatter={(value) => numberWithCommas(value)}
            />
            <Legend verticalAlign="bottom" wrapperStyle={{ paddingBottom: "20px", paddingTop: "30px"}} />
            <Bar dataKey="jumlah" stackId="a" fill="#0288d1" name="Jumlah" />
          </BarChart>
        </ResponsiveContainer>
           ) : (
            <ChartCard>
              <h6 className="text-center text-sm xl:text-lg font-medium">
                Belum Ada Total Buku Tananh Khusus !
              </h6>
            </ChartCard>
      )}
    </ChartCard>

    <ChartCard>
       {isLoading ? ( // Tampilkan CircularProgress jika isLoading true
        <CircularProgress style={{ margin: '50px auto', display: 'block' }} />
    ) : data?.length > 0 ? ( // Cek apakah ada data
        <React.Fragment>
        <TableContainer component={Paper} style={{ marginTop: '20px'  }}>
        <Table>
          <TableHead>
              <TableRow>
              <TableCell align='center' style={{ backgroundColor: '#0288d1', color: 'white', border: '1px solid #ddd', padding: '8px' }}>No</TableCell>
              <TableCell align='center' style={{ backgroundColor: '#0288d1', color: 'white', border: '1px solid #ddd', padding: '8px' }}>Nama Peminjam</TableCell>  
              <TableCell align='center' style={{ backgroundColor: '#0288d1', color: 'white', border: '1px solid #ddd', padding: '8px' }}>Nomor Hak/Warkah</TableCell>  
              <TableCell align='center' style={{ backgroundColor: '#0288d1', color: 'white', border: '1px solid #ddd', padding: '8px' }}>Tahun</TableCell> 
              <TableCell align='center' style={{ backgroundColor: '#0288d1', color: 'white', border: '1px solid #ddd', padding: '8px' }}>ID Pinjam</TableCell> 
              <TableCell align='center' style={{ backgroundColor: '#0288d1', color: 'white', border: '1px solid #ddd', padding: '8px' }}>Jenis Peminjaman</TableCell>
              <TableCell align='center' style={{ backgroundColor: '#0288d1', color: 'white', border: '1px solid #ddd', padding: '8px' }}>Keperluan</TableCell>    
              <TableCell align='center' style={{ backgroundColor: '#0288d1', color: 'white', border: '1px solid #ddd', padding: '8px' }}>Tanggal Input</TableCell> 
              <TableCell align='center' style={{ backgroundColor: '#0288d1', color: 'white', border: '1px solid #ddd', padding: '8px' }}>Tanggal Pinjam</TableCell> 
              <TableCell align='center' style={{ backgroundColor: '#0288d1', color: 'white', border: '1px solid #ddd', padding: '8px' }}>Tanggal Kembali</TableCell> 
              <TableCell align='center' style={{ backgroundColor: '#0288d1', color: 'white', border: '1px solid #ddd', padding: '8px' }}>Status</TableCell>
                {/* Tambahkan lebih banyak TableCell sesuai kebutuhan */}
              </TableRow>
            </TableHead>
            <TableBody>
            {data?.map((item, index) => {
                   const rowNumber = (currentPage - 1) * itemsPerPage + index + 1; 
                   let status;
                   let statusColor;
                   if (item.status === null) {
                     status = 'Waiting';
                     statusColor = '#ed9b40';
                 } else if (item.status === '1' && item.status_pengembalian === '2') {
                     status = 'Selesai';
                     statusColor = '#61c9a8';
                 } else if (item.status === '1' && item.status_pengembalian === '1' && item.status_tu ==='1') {
                   status = 'Pengembalian';
                   statusColor = '#0288d1';
                 }  else if (item.status === '1' && item.status_pengembalian === null && item.status_tu === null) {
                     status = 'Dipinjam';
                     statusColor = '#d64550';
                 } else if (item.status === 'tolak' && item.status_pengembalian === '2' && item.status_tu === '2') {
                   status = 'Ditolak';
                   statusColor = '#d64550';
               }
               return (
                <TableRow key={index}>
                <TableCell align="center">{rowNumber}</TableCell>    <TableCell align="center" style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center', }}>{item.namapeminjam ?  item.namapeminjam : '-'}</TableCell>
                        <TableCell align="center" style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center', }}>{item.nomorhak !== "NULL" ? item.nomorhak : item.nomordi208}</TableCell>
                        <TableCell align="center" style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center', }}>{item.tahun !== "null" ? item.tahun : '-'}</TableCell>
                        <TableCell align="center" style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center', }}>{item.paket}</TableCell>
                        <TableCell align="center" style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center', }}>{item.jenis}</TableCell>
                        <TableCell align="center" style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center', }}>{item.keperluan}</TableCell>
                        <TableCell align="center" style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center', }}>{item.tglinput}</TableCell>
                        <TableCell align="center" style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center', }}>{item.tglpinjam ? item.tglpinjam : '-' }</TableCell>
                        <TableCell align="center" style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center', }}>{item.tglkembali ? item.tglkembali : '-'}</TableCell>
                        <TableCell align="center" style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center', color: statusColor }}>{status}</TableCell>
                </TableRow>
                        );
                        })}
                    </TableBody>
                    </Table>
                </TableContainer>  
     
                        <div style={{ display: 'flex', justifyContent: 'right', marginTop: '20px' }}>
                        <Button onClick={handlePreviousPage} disabled={currentPage === 1} variant="contained" color="warning" size="small" style={{ marginRight: '10px' }}>Previous</Button>
                        <Button onClick={handleNextPage} disabled={data?.length < itemsPerPage} variant="contained" size="small">Next</Button>
                    </div>
            </React.Fragment>
          ) : (
            <ChartCard>
              <h6 className="text-center text-sm xl:text-lg font-medium">
                Belum Ada Data Buku Tananh Khusus !
              </h6>
            </ChartCard>
          )}
</ChartCard>
      </div>
</div>

  );
}
export default BTKhusus;